import { AppLayout } from '../components/AppLayout'
import { TenantRequestsList } from '../features/tenant-requests/components/TenantRequestsList'

export function TenantRequestsPage() {
  return (
    <AppLayout>
      <TenantRequestsList />
    </AppLayout>
  )
}
